<div class="pt-4 w-56" *ngIf="!propupRole.includes('propup-paid-user') || hasSpecialOffer">
  <p class="font-bold">{{'account_status.title' | translate}}</p>
  <p class="font source mt-2">{{'account_status.' + accountStatus | translate }}</p>
  <div class="flex items-center my-4">
    <a href="{{link}}" target="_blank"
       class="text-base font-source font-bold py-2 bg-primary text-white rounded-lg px-3 text-center"
    >{{'account_status.upgrade' | translate}}</a>
  </div>
</div>
